import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=24c5b49c&"
import script from "./HomePage.vue?vue&type=script&lang=ts&"
export * from "./HomePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c5b49c')) {
      api.createRecord('24c5b49c', component.options)
    } else {
      api.reload('24c5b49c', component.options)
    }
    module.hot.accept("./HomePage.vue?vue&type=template&id=24c5b49c&", function () {
      api.rerender('24c5b49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/HomePage.vue"
export default component.exports